export default __webpack_public_path__ + "static/media/summaryImage.25023af6.jpg";